import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const STATS = [
  { value: '300K+', labelKey: 'v2_stats_deliveries' },
  { value: '200+', labelKey: 'v2_stats_couriers' },
  { value: '50+', labelKey: 'v2_stats_restaurants' },
  { value: '3+', labelKey: 'v2_stats_years' },
];

export const StatsStripV2 = () => {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 sm:py-20 overflow-hidden border-y border-border" data-testid="v2-stats">
      <div className="absolute inset-0 bg-gradient-to-r from-fuchsia-900/10 via-indigo-900/20 to-orange-900/10" />
      <div className="absolute inset-0 neon-grid-bg opacity-30" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          {STATS.map((s, i) => (
            <motion.div
              key={s.labelKey}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="text-left"
              data-testid={`v2-stat-${i}`}
            >
              <div className="font-numbers font-black text-4xl sm:text-5xl lg:text-6xl bg-clip-text text-transparent bg-gradient-to-br from-fuchsia-600 via-purple-600 to-orange-500 dark:from-fuchsia-300 dark:via-purple-400 dark:to-orange-300 tracking-tight">
                {s.value}
              </div>
              <div className="mt-2 text-foreground/60 text-sm sm:text-base font-medium uppercase tracking-wider">
                {t(s.labelKey)}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
